((MailChimp, $) => {
  'use strict';

  let $form;
  let $notification;

  const cacheDom = () => {
    $form = $('.js-mailchimp-footer');
    $notification = $('.js-mailchimp-notification');
  };

  const showNotification = (message) => {
    $form.hide();
    $notification.text(message).fadeIn().css('display', 'inline-block');
  };

  const register = () => {
    const successMessage = 'Thank you! Verification email sent!';
    const errorMessage = 'An error was encountered. Please try again later.';
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8',
      error(err) {
        if (err.status === 200) {
          showNotification(successMessage);
        } else {
          showNotification(errorMessage);
        }
      },
      success() {
        showNotification(successMessage);
      }
    });
  };

  const submitBind = () => {
    $form.on('submit', (event) => {
      event.preventDefault();
      register();
    });
  };

  const bindUIActions = () => {
    submitBind();
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  MailChimp.init = init;
})(window.MailChimp = window.MailChimp || {}, jQuery);
